import { render, staticRenderFns } from "./yc-sales-volume-detail.vue?vue&type=template&id=59f2e185&scoped=true&"
import script from "./yc-sales-volume-detail.vue?vue&type=script&lang=js&"
export * from "./yc-sales-volume-detail.vue?vue&type=script&lang=js&"
import style0 from "./yc-sales-volume-detail.vue?vue&type=style&index=0&id=59f2e185&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f2e185",
  null
  
)

export default component.exports